import queryString from 'query-string';

const urlParams = queryString.parse(window.location.search) || {};

const QueryStringHelper = {
  isApp: urlParams.channel && (urlParams.channel as string).toLowerCase() === 'app',
  isBpr: urlParams.bpr,
};

export { QueryStringHelper };
